import React from 'react';

export function ErrorMessage(props: { error: string }) {
  return <p className="tw:py-2 tw:text-primary">{props.error}</p>;
}
